/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Audit_Details_Uno_Tool_Declined_DescInputs */



/**
* | output |
* | --- |
* | "Uno tool: {tool}, declined" |
*
* @param {Audit_Details_Uno_Tool_Declined_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_uno_tool_declined_desc = /** @type {((inputs: Audit_Details_Uno_Tool_Declined_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Uno_Tool_Declined_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Uno-Werkzeug: ${i?.tool}, abgelehnt`)
	return /** @type {LocalizedString} */ (`Uno tool: ${i?.tool}, declined`)
});